import { Component, OnInit,Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GridApi } from 'ag-grid-community';
import { MedicalFileService } from 'src/app/medical-file/medical-care-plan/medical.file.service';
import { MasterService } from 'src/app/masters/master.service';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from 'src/app/utils/shared.service';
import { GridNgSelectDataComponent } from 'src/app/common/grid-utils/grid-ng-select-component';
import { CustomDateComponent } from 'src/app/common/grid-utils/custom-date-component.component';
import { Parameter } from 'src/app/common/grid-utils/parameter.model';
import * as CommonConstants from '../../utils/common.constants';
import swal from 'sweetalert2';
import { LoaderService } from 'src/app/common/loader.service';
@Component({
  selector: 'app-abroad-treatment',
  templateUrl: './abroad-treatment.component.html',
  styleUrls: ['./abroad-treatment.component.scss']
})
export class AbroadTreatmentComponent implements OnInit {
  @Input() medFileId;
  gridApi: GridApi;
  specialTreatmentList = [];
  rowData = [];
  status;
  masterValues=[];
  colDefs;
  frameworkComponents;
  procedure=[];
  traitments=[];
  splTreatments=[];
  specialities=[];
  specialistList=[];
  partnerList=[];
  ptype=[CommonConstants.PARTNER_PRACTITIONER_TYPE,CommonConstants.PARTNER_HOSPITAL_TYPE];
  PARAM_KEY=[CommonConstants.STATUS];
  SERVICE_KEYS=[CommonConstants.SPL_TREATMENT_MED_FILE];
  constructor(private modal: NgbModal, private masterService: MasterService, private sharedService: SharedService,
    private medicalFileService: MedicalFileService, private toastrService: ToastrService,private loaderService:LoaderService) {
      this.frameworkComponents = {
        ngSelectEditor: GridNgSelectDataComponent,
        agDateInput: CustomDateComponent
      }
  }

  ngOnInit() {
   this.loadMaster();
   this.loadAbroadTreatmentDetails();
  }
  loadMaster() {
    this.masterService.getMastersByParamKey(this.PARAM_KEY).subscribe(response => {
      if (response && response['result']) {
        this.masterValues = response['result'];
        this.status=this.masterValues.filter(master => master.paramKey === CommonConstants.STATUS);
      }
    });
    this.masterService.getSpecialities().subscribe(response => {
      if (response && response['result']) {
        this.specialities = response['result'];
      }
    })
   /*  this.masterService.getPartnersByPartnerType(this.ptype);
    this.masterService.partnerList.subscribe(value => {
      this.specialistList = value;
    }); */
    this.filterPartnerTypes();
  }
  filterPartnerTypes() {
    if (this.partnerList && this.partnerList.length==0) {
      this.masterService.getPartnersByPartnerType(this.ptype);
      this.masterService.partnerList.subscribe(value => {
        this.partnerList = value;
        this.setPartners();
      })
    } else {
      this.setPartners();
    }

  }

  setPartners() {
    this.specialistList = this.partnerList.filter(item => item.partnertypeid === CommonConstants.PARTNER_PRACTITIONER_TYPE);
  }
  loadAbroadTreatmentDetails() {
    this.medicalFileService.getDetailsByKeys(this.medFileId, this.SERVICE_KEYS).subscribe(response => {
      if (response && response['code'] === 'S0000' && response['result']) {
        this.splTreatments = response['result'][CommonConstants.SPL_TREATMENT_MED_FILE].map(item =>({
          ...item,
          practionarvalue: item.prtieId && item.prtieId != "" ? this.specialistList.find(obj => obj.partnerid === +item.prtieId).partnername : null,
          specialityValue: item.spltyId && item.spltyId != "" ? this.specialities.find(obj => obj.spltyId === +item.spltyId).spltyDescEn : null,
          statusvalue: item.statuCode && item.statuCode != "" ? this.status.find(obj => obj.id === +item.statuCode).value : null
        }));
      } else {
        swal.fire("Error", response['message'], 'error');
      }
    },
      error => {
        swal.fire("Error", "Error Occured While Fetching Medical File Details", 'error');
      })
  }
  defaultColDef = {
    editable: true,
    singleClickEdit: true
  }

  ngAfterViewInit() {
  }

  onGridReady(params) {
    this.gridApi = params.api;
  }
  openGridModal(modalId) {
    this.modal.open(modalId, { size: 'lg', windowClass: 'full-width', container: '.page-content' });
    if (!this.colDefs) {
      this.getGrids();
    }
  }

  addNewGridRow() {
    const newRow = {
      medstDtDate: '', sttypCode: '', medstVaProcedureName: '', spltyId: '', prtieId: '', medstVaPrescribedDoses: '',
      medstVaGivenDoses: '', medstNuDurationDay: '',medstVaCondition: '', statuCode: ''
    };
    this.rowData.push(newRow);
    this.gridApi.setRowData(this.rowData);
  }

  getGrids() {
    this.colDefs = [
      { headerName: 'Date', field: 'medstDtDate', cellEditor: 'agDateInput'},
      { headerName: 'sttypCode', field: 'sttypCode',hide: true},
      { headerName: 'Type', field: 'typevalue', cellEditor: 'ngSelectEditor',
      cellEditorParams: { values: this.status, dataColumn: 'sttypCode', model: new Parameter(), objectData: ['id', 'value'] }},
      { headerName: 'Procedure Name', field: 'medstVaProcedureName' },
      { headerName: 'spltyId', field: 'spltyId' ,hide: true},
      { headerName: 'Speciality', field: 'specialityValue', cellEditor: 'ngSelectEditor',
      cellEditorParams: { values: this.specialities, dataColumn: 'spltyId', model: new Parameter(), objectData: ['spltyId', 'spltyDescEn'] }},
      { headerName: 'prtieId', field: 'prtieId',hide: true },
      { headerName: 'Speciliast', field: 'practionarvalue', cellEditor: 'ngSelectEditor',
      cellEditorParams: { values: this.specialistList, dataColumn: 'prtieId', model: new Parameter(), objectData: ['partnerid', 'partnername'] }},
      { headerName: 'Prescribed Dos', field: 'medstVaPrescribedDoses' },
      { headerName: 'Given Doses', field: 'medstVaGivenDoses' },
      { headerName: 'Duration', field: 'medstNuDurationDay' },
      { headerName: 'Condition', field: 'medstVaCondition' },
      { headerName: 'statuCode', field: 'statuCode', hide: true },
      { headerName: 'Status', field: 'statusvalue', cellEditor: 'ngSelectEditor',
      cellEditorParams: { values: this.status, dataColumn: 'statuCode', model: new Parameter(), objectData: ['id', 'value'] }
    },
    ];
   // private Long medstId;

   // private Long meddoId;
  
   // private Long medfiId;
  
  }

  saveSplTreatment() {
    this.rowData = this.rowData.map(item => ({
      ...item,
      'medfiId': this.medFileId
    }));
    this.loaderService.display(true);
    this.medicalFileService.saveSplTreatment(this.rowData).subscribe(res => {
      if (res && res["result"] && res['code']==='0') {
        this.loaderService.display(false);
        swal.fire("Success", res['message'] ,'success');
        for(let item of res["result"]){
          item["practionarvalue"]= item.prtieId && item.prtieId != "" ? this.specialistList.find(obj => obj.partnerid === +item.prtieId).partnername : null;
           item["specialityValue"]= item.spltyId && item.spltyId != "" ? this.specialities.find(obj => obj.spltyId === +item.spltyId).spltyDescEn : null;
           item["statusvalue"]= item.statuCode && item.statuCode != "" ? this.status.find(obj => obj.id === +item.statuCode).value : null;
          this.splTreatments.push(item);
        }
         this.splTreatments = Object.values(this.splTreatments.reduce((acc,c)=>(acc[c.medstId]=c,acc),{}));
        this.splTreatments = [...this.splTreatments];
        this.modal.dismissAll();
      }else{
        this.loaderService.display(false);
        swal.fire("Error", res['message'] ,'error');
      }
    }, error => {
      this.loaderService.display(false);
      swal.fire("Error", "Error Occured While Saving Special Treatment", 'error');
    })
  }
  onSplTreatmentRowSelect(addSpltreatment){
    this.getGrids();
    this.modal.open(addSpltreatment, { size: 'lg', windowClass: 'full-width', container: '.page-content' });
    this.rowData = this.splTreatments;
  }
}
